import { render, staticRenderFns } from "./FavoritesWidget.vue?vue&type=template&id=0b50e4f4&scoped=true"
import script from "./FavoritesWidget.vue?vue&type=script&lang=js"
export * from "./FavoritesWidget.vue?vue&type=script&lang=js"
import "./FavoritesWidget.vue?vue&type=style&index=0&id=0b50e4f4&prod&scoped=true&lang=css"
/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50e4f4",
  null
  
)

export default component.exports